import React, { useContext, useEffect, useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { addPersonalData } from "../../Redux/Actions/CardAction";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
// import { CardContext } from "../../store/CardContext";
const Forms = ({ edit }) => {
  // const dispatch = useDispatch();
  // const { personalDetails } = useSelector((state) => state.cardReducer);
  // const { validationCheck } = useSelector((state) => state.cardReducer);
  // const mobileRegex = /^(\d{3})[- ]?(\d{3})[- ]?(\d{4})$/;
  const regex = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;

  // const initialValues = {
  //   name: personalDetails?.name,
  //   emailAddress: personalDetails?.emailAddress,
  //   companyName: personalDetails?.companyName,
  //   companyDesignation: personalDetails?.companyDesignation,
  //   mobile: personalDetails?.mobile,
  //   about: personalDetails?.about,
  // };

  // const [userData, setUserData] = useState(initialValues)
  const [userData, setUserData] = useState('')
  // const [userContextData, setUserContextData] = useContext(CardContext)


  // const number = personalDetails?.phone ? '' + personalDetails?.phone : '971'
  const number = '971'

  // const secondaryNumber = personalDetails?.secondaryPhone ? '' + personalDetails?.secondaryPhone : '971'
  const secondaryNumber = '971'

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUserData({ ...userData, [name]: value });

  };
  // useEffect(() => {
  //   dispatch(addPersonalData(userData));
  // }, [userData])

  // useEffect(() => {

  //   setUserData({
  //     name: userContextData?.name,
  //     email: userContextData?.email,
  //     secondaryEmail: userContextData?.secondaryEmail,
  //     companyName: userContextData?.companyName,
  //     companyDesignation: userContextData?.companyDesignation,
  //     phone: userContextData?.phone,
  //     secondaryPhone: userContextData?.secondaryPhone,
  //     about: userContextData?.about,
  //   })
  // }, [userContextData]);
  // console.log(userContextData);

  return (
    <>
      <div className="grid gap-4 mb-6 md:grid-cols-2">
        <div>
          <label
            for="first_name"
            className="block mb-2 text-sm font-medium text-gray-900 "
          >
            Full Name
          </label>
          <input
            type="text"
            name="name"
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5  "
            placeholder="Full Name"
            onChange={handleChange}
            value={userData?.name || ""}
          />
          {/* {userData?.name || (!validationCheck && !edit) ? (
            ""
          ) : (
            <p className="text-red-500">Name is required</p>
          )} */}
        </div>
        <div>
          <label
            for="first_name"
            className="block mb-2 text-sm font-medium text-gray-900 "
          >
           Constituency
          </label>
          <input
            type="text"
            name="companyDesignation"
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 "
            placeholder="Company Designation"
            onChange={handleChange}
            value={userData["companyDesignation"] || ""}
            // value={personalDetails?.companyDesignation || ""}
          />
          {/* {userData?.companyDesignation || (!validationCheck && !edit) ? (
            ""
          ) : (
            <p className="text-red-500">Designation is required</p>
          )} */}
        </div>
        <div>
          <label
            for="first_name"
            className="block mb-2 text-sm font-medium text-gray-900 "
          >
            Email
          </label>
          <input
            type="text"
            name="email"
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 "
            placeholder="Email"
            onChange={handleChange}
            value={userData["email"] || ""}
            // value={personalDetails?.email || ""}
          />


          {/* {userData?.email || (!validationCheck && !edit) ? (
            userData?.email ? (regex.test(userData.email) ? (
              ""
            ) : (
              <p className="text-red-500">Enter Valid Email</p>
            )) : ''

          ) : (
            <p className="text-red-500">email is required</p>
          )} */}

        </div>
        <div>
          <label
            for="first_name"
            className="block mb-2 text-sm font-medium text-gray-900 "
          >
           Headquarters Email
          </label>
          <input
            type="text"
            name="secondaryEmail"
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 "
            placeholder="Secondary Email"
            onChange={handleChange}
            value={userData["secondaryEmail"] || ""}
            // value={personalDetails?.secondaryEmail || ""}
          />
          {/* { userData?.secondaryEmail ? (regex.test(userData.secondaryEmail) ? (
              ""
            ) : (
              <p className="text-red-500">Enter Valid Email</p>
            )) : ''} */}
        </div>
        

        <div>
          <label
            for="first_name"
            className="block mb-2 text-sm font-medium text-gray-900 "
          >
            Mobile Number
          </label>
          
          <PhoneInput country={"eg"} enableSearch={true} value={number} onChange={(phone) => setUserData({ ...userData, phone: phone })} inputStyle={{ width: '230px', height: '10px' }} />
          {/* {userData?.phone || (!validationCheck && !edit) ? (
            userData?.phone ? (
              number?.length >= 10 ? "" :
                <p className="text-red-500">Enter Valid Mobile Number</p>

            ) : '') : (
            <p className="text-red-500">Mobile Number is required</p>
          )} */}
        </div>
        <div>
          <label
            for="first_name"
            className="block mb-2 text-sm font-medium text-gray-900 "
          >
            Headquarters Mobile Number
          </label>
          
          <PhoneInput country={"eg"} enableSearch={true} value={secondaryNumber} onChange={(secondaryPhone) => setUserData({ ...userData, secondaryPhone: secondaryPhone })} inputStyle={{ width: '230px', height: '10px' }} />
          {/* {
            userData?.secondaryPhone ? (
              secondaryNumber?.length >= 10 ? "" :
                <p className="text-red-500">Enter Valid Mobile Number</p>

            ) : ''} */}
        </div>
      </div>
      {/* <div className=" mb-5 ">
        <label
          for="first_name"
          className="block mb-2 text-sm font-medium text-gray-900"
        >
          Company Name
        </label>
        <input
          type="text"
          name="companyName"
          className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 "
          placeholder="Company Name"
          onChange={handleChange}
          value={userData["companyName"] || ""}
          // value={personalDetails?.companyName || ""}
        />
      </div> */}
      {/* <div>
        <label
          for="first_name"
          className="block mb-2 text-sm font-medium text-gray-900 "
        >
          About
        </label>
        <textarea
          type="textarea"
          name="about"
          className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full h-32 p-2.5 "
          placeholder="About You"
          onChange={handleChange}
          value={userData["about"] || ""}
          // value={personalDetails?.about || ""}
        />

      </div> */}
    </>
  );
};

export default Forms;
